/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetMerchantGeneralBlock200ResponseInnerAllowedOrganizationListInner } from './get-merchant-general-block200-response-inner-allowed-organization-list-inner';

/**
 * 
 * @export
 * @interface GetMerchantGeneralBlock200ResponseInner
 */
export interface GetMerchantGeneralBlock200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlock200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlock200ResponseInner
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlock200ResponseInner
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlock200ResponseInner
     */
    'acquirerId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlock200ResponseInner
     */
    'patternType': GetMerchantGeneralBlock200ResponseInnerPatternTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlock200ResponseInner
     */
    'storeType': GetMerchantGeneralBlock200ResponseInnerStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlock200ResponseInner
     */
    'createdAt': string;
    /**
     * 
     * @type {Array<GetMerchantGeneralBlock200ResponseInnerAllowedOrganizationListInner>}
     * @memberof GetMerchantGeneralBlock200ResponseInner
     */
    'allowedOrganizationList': Array<GetMerchantGeneralBlock200ResponseInnerAllowedOrganizationListInner>;
}

export const GetMerchantGeneralBlock200ResponseInnerPatternTypeEnum = {
    exact: 'EXACT',
    prefix: 'PREFIX',
    suffix: 'SUFFIX',
    regexp: 'REGEXP',
    unknown: 'UNKNOWN'
} as const;

export type GetMerchantGeneralBlock200ResponseInnerPatternTypeEnum = typeof GetMerchantGeneralBlock200ResponseInnerPatternTypeEnum[keyof typeof GetMerchantGeneralBlock200ResponseInnerPatternTypeEnum];
export const GetMerchantGeneralBlock200ResponseInnerStoreTypeEnum = {
    all: 'ALL',
    physicalStore: 'PHYSICAL_STORE',
    ecStore: 'EC_STORE',
    unknown: 'UNKNOWN'
} as const;

export type GetMerchantGeneralBlock200ResponseInnerStoreTypeEnum = typeof GetMerchantGeneralBlock200ResponseInnerStoreTypeEnum[keyof typeof GetMerchantGeneralBlock200ResponseInnerStoreTypeEnum];


